<template>
  <div class="cmp-distribution-order-invoice-contact-summary">
    <div style="margin-bottom: 10px" class="ut-flex">
      <h4 style="font-weight: bold">{{ $t("invoice_contact") }}</h4>
      <img
        style="margin-top: 0px"
        @click="(e) => onClickEditIcon(e)"
        src="static/icons/edit-blue.svg"
        class="dt-icon v5 s1"
      />
    </div>
    <h4 v-if="contact && contact.company_name && contact.company_name != ''">
      {{ contact.company_name }}
    </h4>
    <h4 v-if="contact && contact.first_name && contact.last_name">
      {{ `${contact.first_name} ${contact.last_name}` }}
    </h4>
    <h4 v-if="contact && contact.address1">{{ contact.address1 }}</h4>
    <h4 v-if="contact && contact.postalcode">
      {{ `${contact.postalcode} ${contact.city}` }}
    </h4>
    <h4 v-if="contact && contact.country">{{ contact.country }}</h4>
    <h4 v-if="contact && contact.phone1">{{ contact.phone1 }}</h4>
    <h4 v-if="contact && contact.phone2">{{ contact.phone2 }}</h4>
    <h4 v-if="contact && contact.email1">{{ contact.email1 }}</h4>
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      default: () => {},
    },
  },
  components: {},

  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onClickEditIcon: function () {
      //console.log("document.getElementById('document')",document.getElementById('deliveryInfoDiscount'))
      document.getElementById("contact").scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss">
.cmp-distribution-order-invoice-contact-summary {
  p {
    margin-bottom: 0px;
  }
}
</style>